/** API route map: URLS.Controller.CandidateRecommendation */
export const CandidateRecommendation = {
      Name: 'CandidateRecommendation/',
      GetAll: 'candidate-recommendation',
};
